import { render, staticRenderFns } from "./nestedWithUL.vue?vue&type=template&id=fd31ccee&scoped=true"
import script from "./nestedWithUL.vue?vue&type=script&lang=js"
export * from "./nestedWithUL.vue?vue&type=script&lang=js"
import style0 from "./nestedWithUL.vue?vue&type=style&index=0&id=fd31ccee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31ccee",
  null
  
)

export default component.exports